import { IHttpService, IPromise, IQService, IHttpPromise } from "angular";
import { IUserAccount } from "../../typings/board/Models";

export const USERS_SERVICE :string = "usersService";
export class UsersService {
    static $inject = ["$http", "$q"];
    constructor(private $http: IHttpService, private $q: IQService) { }

    users(): IPromise<IUserAccount[]> {
        return this.$http.get<IUserAccount[]>("api/users/getusers").then(response => {
            return response.data;
        });
    }

    delete(userId: string): IHttpPromise<void> {
        return this.$http({
            method: "POST",
            url: "api/users/delete",
            headers: {
                "Content-Type": undefined
            },
            data: { userId: userId },
            transformRequest: function (data:any):FormData {
                var formData :FormData = new FormData();
                formData.append("userId", data.userId);
                return formData;
            }
        });
    }

    enableEmail(email: string): any {
        return this.$http({
            method: "POST",
            url: "api/users/EnableUserRegistrationAsync",
            headers: {
                "Content-Type": undefined
            },
            data: { email: email },
            transformRequest: function (data:any):FormData {
                var formData :FormData = new FormData();
                formData.append("email", data.email);
                return formData;
            }
        })
        .then(response => response.data);
    }

    createFirstUser(password: string): any {
        return this.$http({
            method: "POST",
            url: "api/users/createfirstuser",
            headers: {
                "Content-Type": undefined
            },
            data: { password: password },
            transformRequest: function (data:any):FormData {
                var formData :FormData = new FormData();
                formData.append("password", data.password);
                return formData;
            }
        })
        .then(response => response.data);
    }

    resendActivationMail(userId: string): any {
        return this.$http({
            method: "POST",
            url: "api/users/ResendActivationMailAsync",
            headers: {
                "Content-Type": undefined
            },
            data: { userId: userId },
            transformRequest: function (data:any):FormData {
                var formData :FormData = new FormData();
                formData.append("userId", data.userId);
                return formData;
            }
        })
        .then(response => response.data);
    }
}


// WEBPACK FOOTER //
// ./app/users/users.service.ts